export default "__VITE_ASSET__DHlV4Cv6__"